
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/plataforma",
      function () {
        return require("private-next-pages/pt-br/plataforma/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/plataforma"])
      });
    }
  